import { URI } from '@/config/config'

export default async ({ rootState }, payload) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
    body: JSON.stringify(payload)
  }

  const userLoginInfoResult = await fetch(`${URI}payment/add-bonus`, opts);
  const jsonResult = await userLoginInfoResult.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }
  
  return jsonResult;
}